export const environment = {
  production: true,
  domain: 'ssp.admaxhub.com',
  apiUrl: 'https://amh-api-gateway-fe-1r72n2y7.an.gateway.dev/api/v1',
  API_KEY: 'AIzaSyDYHssjk3UgLxTfgtGUosGp60oMktKrouU',
  appName: 'AdMax Hub - SSP',
  geoapifyApiKey: '2825cff5a6fc4254838f14e73c1a9ecb',
  googleClientId: '137564986543-6t7db48s2bdisnhhvfgiuvdvg7goscas.apps.googleusercontent.com',
  userType: 'Media Owners' as const,
  features: {
    auth: false,
    dsp: false,
    ssp: true
  },
  allowedRoutes: ['/main/inventory', '/main/welcome'],
  restrictedRoutes: ['/main/campaign'],
  loginDomain: 'https://login.admaxhub.com'
};
